import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'
import { fetchProfilingCodesByTypeAndMarket } from 'legacy/lut/services/profiling/codes'

import { Market, Region } from 'clickNgo/configs/geo'
import { IContactFlag } from 'clickNgo/entities/contactFlag'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'

import { fetchToolsCodeRules } from './fetchToolsCodeRules'

interface Params {
  market: Market
  region: Region
  country: string
  contactFlags: IContactFlag[]
  type: ProfilingCodeType.UserRights | ProfilingCodeType.Tools | ProfilingCodeType.Campaigns
}

interface FetchContactFlagProfilingCodesParams {
  market: Market
  country: string
  type: ProfilingCodeType.UserRights | ProfilingCodeType.Tools | ProfilingCodeType.Campaigns
}

const normalizeStr = (str: string) => str.toLowerCase().trim()

export const filterAvailableContactFlags = async (params: {
  profilingCodeList: IProfilingCode[]
  contactFlags: IContactFlag[]
  type: ProfilingCodeType
}) => {
  if (params.type === ProfilingCodeType.Tools) {
    const flagRules = await fetchToolsCodeRules({ cacheKey: 'fetchAvailableContactFlags' })
    const availableTools = new Set(flagRules.map((flag) => normalizeStr(flag.toolsFlagCode)))

    return params.profilingCodeList
      .filter(
        (profilingCode) =>
          !params.contactFlags.some(
            (flag) => normalizeStr(profilingCode.code) === normalizeStr(flag.code)
          )
      )
      .filter((profilingCode) => availableTools.has(normalizeStr(profilingCode.code)))
  }

  return params.profilingCodeList.filter(
    (profilingCode) =>
      !params.contactFlags.some(
        (flag) => normalizeStr(profilingCode.code) === normalizeStr(flag.code)
      )
  )
}

export const fetchContactFlagProfilingCodes = ({
  market,
  type,
  country,
}: FetchContactFlagProfilingCodesParams): Promise<IProfilingCode[]> => {
  return fetchProfilingCodesByTypeAndMarket({ type, market, country }, { cacheKey: type + market })
}

export const fetchAvailableContactFlags = async ({
  contactFlags,
  market,
  type,
  country,
}: Params): Promise<IProfilingCode[]> => {
  const profilingCodeList = await fetchContactFlagProfilingCodes({ market, type, country })

  return filterAvailableContactFlags({ contactFlags, profilingCodeList, type })
}
